import {
  Card,
  Text,
  VStack,
  Flex,
  Box,
  Avatar,
  useColorModeValue,
} from "@chakra-ui/react";
import { FC, useMemo, useState } from "react";
import VerifiedDot from "../../atoms/VerifiedDot";
import { colors } from "@/components/Theme/colors";
import { User } from "@/schemaTypes";
import ChannelLeaderModal from "../../organisms/ChannelLeaderModal";

interface ChannelLeadersListProps {
  leaders: User[];
}

const ChannelLeadersList: FC<ChannelLeadersListProps> = ({ leaders }) => {
  const borderColor = useColorModeValue(colors.neutral[100], "gray.700");
  const cardBg = useColorModeValue("white", "gray.800");

  const [selectedLeader, setSelectedLeader] = useState<User | undefined>();
  const [isOpen, setIsOpen] = useState(false);
  const hoverBg = useColorModeValue("gray.50", "gray.700");

  const openModal = (leader: User) => {
    setSelectedLeader(leader);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const leadersToShow = useMemo(() => {
    return leaders.slice(0, 3);
  }, [leaders]);

  return (
    <Card
      bg={cardBg}
      borderRadius="6px"
      boxShadow="md"
      border="1px solid"
      shadow={0}
      borderColor={borderColor}
      maxW={{ base: "100%", md: "330px" }}
      width={{ base: "100%", md: "330px" }}
      p="24px"
    >
      <Text variant="body" fontWeight="600" mb="16px" textAlign="center">
        Líderes de este canal
      </Text>
      <VStack spacing="16px" align="stretch">
        {leadersToShow.map((leader) => (
          <Flex
            key={leader.id}
            align="center"
            gap={3}
            p={3}
            borderRadius="6px"
            border="1px solid"
            borderColor={borderColor}
            cursor="pointer"
            _hover={{ bg: hoverBg }}
            onClick={() => openModal(leader)}
          >
            <Box position="relative">
              <Avatar
                src={leader.avatarUrl ?? undefined}
                name={leader.name}
                size="md"
              />
              <Box position="absolute" bottom="-2px" right="-2px">
                <VerifiedDot size={18} />
              </Box>
            </Box>
            <Box flex="1" minW={0}>
              <Text variant="caption" noOfLines={1}>
                {leader.name} {leader.lastName || ""}
              </Text>
            </Box>
          </Flex>
        ))}
      </VStack>
      <ChannelLeaderModal
        leader={selectedLeader}
        isOpen={isOpen}
        onClose={closeModal}
      />
    </Card>
  );
};

export default ChannelLeadersList;
